/* beautiful-react-hooks version: 0.27.4 */
var isApiSupported = function isApiSupported(api) {
  return api in window;
};

export default isApiSupported;
